import { Type } from '@angular/core';
import _ from 'lodash';
import { BrickDefinition } from '../../samwebDescription/samweb/brickDefinition';
import { BasicBrickComponent } from './basic-brick-component';
import { AgentDetailsBrickComponent } from './calling/agent-details-brick/agent-details-brick.component';
import { AgentListBrickComponent } from './calling/agent-list-brick/agent-list-brick.component';
import { CallControlBrickDefaultComponent } from './calling/call-control-brick/call-control-brick.default.component';
import { CallHistoryBrowserBrickComponent } from './calling/call-history-browser-brick/call-history-browser-brick.component';
import { CallWaitListBrickComponent } from './calling/call-wait-list-brick/call-wait-list-brick.component';
import { PresenceDurationBrickDefaultComponent } from './calling/presence-duration-brick/presence-duration-brick.default.component';
import { SingleCallTagEditorBrickComponent } from './calling/single-call-tag-editor-brick/single-call-tag-editor-brick.component';
import { SkillBrowserComponent } from './calling/skill-browser/skill-browser.component';
import { StageBrickComponent } from './calling/stage-brick/stage-brick.component';
import { DirectoryBrickComponent } from './directory/directory-brick/directory-brick.component';
import { DirectoryDetailsBrickComponent } from './directory/directory-details-brick/directory-details-brick.component';
import { DynamicActionsBrickComponent } from './dynamic-actions-brick/dynamic-actions-brick.component';
import { BrickNotAllowedBrickComponent } from './error/brick-not-allowed-brick/brick-not-allowed-brick.component';
import { BrickNotFoundBrickComponent } from './error/brick-not-found-brick/brick-not-found-brick.component';
import { BrickNotReadyBrickComponent } from './error/brick-not-ready-brick/brick-not-ready-brick.component';
import { InnerWallBrickComponent } from './layout/inner-wall-brick/inner-wall-brick.component';
import { TabBrickComponent } from './layout/tab-brick/tab-brick.component';
import { ToolbarBrickDefaultComponent } from './layout/toolbar-brick/toolbar-brick.default.component';
import { SkillBrowserMailComponent } from './mailing/skill-browser/skill-browser-mail/skill-browser-mail.component';
import { MailWaitlistComponent } from './mailing/waitlist/mail-waitlist/mail-waitlist.component';
import { GrafanaDashboardViewerBrickComponent } from './statistics/grafana-dashboard-viewer-brick/grafana-dashboard-viewer-brick.component';
import { UserStatusBrickDefaultComponent } from './user/user-status-brick/user-status-brick.default.component';
import { ClockBrickComponent } from './utility/clock-brick/clock-brick.component';
import { LoadTestBrickComponent } from './utility/load-test-brick/load-test-brick.component';
import { WebviewerBrickComponent } from './webviewer-brick/webviewer-brick.component';

export interface BrickSpecification {
   definition: BrickDefinition;
   component: Type<BasicBrickComponent>;
}

export class BrickRegistry {
   public static registeredBricks: Type<BasicBrickComponent>[] = [
      AgentDetailsBrickComponent,
      AgentListBrickComponent,
      BrickNotAllowedBrickComponent,
      BrickNotReadyBrickComponent,
      BrickNotFoundBrickComponent,
      CallControlBrickDefaultComponent,
      CallHistoryBrowserBrickComponent,
      CallWaitListBrickComponent,
      ClockBrickComponent,
      DirectoryBrickComponent,
      DynamicActionsBrickComponent,
      GrafanaDashboardViewerBrickComponent,
      InnerWallBrickComponent,
      LoadTestBrickComponent,
      MailWaitlistComponent,
      PresenceDurationBrickDefaultComponent,
      SingleCallTagEditorBrickComponent,
      SkillBrowserComponent,
      SkillBrowserMailComponent,
      StageBrickComponent,
      TabBrickComponent,
      ToolbarBrickDefaultComponent,
      UserStatusBrickDefaultComponent,
      WebviewerBrickComponent,
      DirectoryDetailsBrickComponent,
   ];

   public static brickSpecifications(): BrickSpecification[] {
      return _(BrickRegistry.registeredBricks)
         .map(
            (x: any) =>
               <BrickSpecification>{
                  component: x,
                  definition: x.samWebBrickDefinition,
               }
         )
         .value();
   }
}
